const OPENPAY_JS_URL =
  "https://resources.openpay.mx/lib/openpay-js/1.2.38/openpay.v1.min.js";
const OPENPAY_DATA_URL =
  "https://resources.openpay.mx/lib/openpay-data-js/1.2.38/openpay-data.v1.min.js";

let openPayPromise: Promise<void> | null = null;

function loadScript(src: string) {
  return new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${src}"]`,
    );
    if (existing) {
      if ((existing as any).__codexLoaded) return resolve();
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error(`Failed: ${src}`)), {
        once: true,
      });
      return;
    }

    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.defer = true;
    s.addEventListener("load", () => {
      (s as any).__codexLoaded = true;
      resolve();
    });
    s.addEventListener("error", () => reject(new Error(`Failed: ${src}`)));
    document.head.appendChild(s);
  });
}

export function loadOpenPay() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.OpenPay) return Promise.resolve();
  if (!openPayPromise) {
    openPayPromise = Promise.all([
      loadScript(OPENPAY_JS_URL),
      loadScript(OPENPAY_DATA_URL),
    ]).then(() => undefined);
  }
  return openPayPromise;
}
